import { render, staticRenderFns } from "./AddressAssetList.vue?vue&type=template&id=c4ac8c48&"
import script from "./AddressAssetList.vue?vue&type=script&lang=js&"
export * from "./AddressAssetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports